
export const auth = {

  // User object will let us check authentication status
  user: {
    authenticated: false
  },

  // Send a request to the login URL and save the returned JWT
  login(id_token, access_token)
  {
      localStorage.setItem('id_token', id_token)
      localStorage.setItem('access_token', access_token)

      this.user.authenticated = true
  },

  signup(context, creds, redirect)
  {
    //context.$http.post(SIGNUP_URL, creds, (data) =>
    //{
    //  localStorage.setItem('id_token', data.id_token)
    //  localStorage.setItem('access_token', data.access_token)

    //  this.user.authenticated = true

    //  if (redirect) {
    //    router.go(redirect)
    //  }

    //}).error((err) =>
    //{
    //  context.error = err
    //})

    /////////////////////////////////
    //Call Post method to post Info
    /////////////////////////////////
  },

  // To log out, we just need to remove the token
  logout()
  {
    localStorage.removeItem('id_token')
    localStorage.removeItem('access_token')
    localStorage.removeItem('store')
    this.user.authenticated = false
  },

  checkAuth()
  {
    var jwt = localStorage.getItem('access_token')
    if (jwt) {
      this.user.authenticated = true
      return true
    }
    else {
      this.user.authenticated = false
      return false
    }
  },

  //The object to be passed as a header for authenticated requests
  getAuthHeader()
  {
    var header = 'Bearer ' + localStorage.getItem('access_token')
    return {
      header
    }
  }
}







// WEBPACK FOOTER //
// ./src/auth/index.js